import React from "react";
import { Grid, Typography, Button, Tooltip } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import BusinessIcon from "@mui/icons-material/Business";
import SyncIcon from "@mui/icons-material/Sync";
import { useTranslation } from "react-i18next";
function CustomerCard({ customers, isApprovalMode, handleViewDetails, handleSync,getDropdownLabel }) {
  const { t, i18n } = useTranslation();
  // Status colors (matching your OrderCard style)
  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "approved":
        return "#CCF9E2";
      case "pending":
        return "#FCDF80";
      case "rejected":
        return "#F2D7D7";
      default:
        return "#E5E7EB";
    }
  };

  const getStatusTextColor = (status) => {
    switch (status?.toLowerCase()) {
      case "approved":
        return "#10472A";
      case "pending":
        return "#524906";
      case "rejected":
        return "#8D1A1A";
      default:
        return "#545454";
    }
  };

  // 📅 Formatters
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, '0');
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();

    // Force LTR direction using Unicode character
    return `\u202A${day} ${month} ${year}\u202C`;
  };


  const formatTime = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);

    // Get time parts
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';

    // Convert to 12-hour format
    hours = hours % 12;
    hours = hours ? hours : 12; // Handle midnight (0 hours)

    // Pad with leading zeros
    const hoursStr = String(hours).padStart(2, '0');
    const minutesStr = String(minutes).padStart(2, '0');

    // Force LTR direction using Unicode character
    return `\u202A${hoursStr}:${minutesStr} ${ampm}\u202C`;
  };

  return (
    <Grid
      container
      spacing={1}
      sx={{
        width: "100%",
        pt: "1vh",
        justifyContent: "center",
      }}
    >
      {customers?.length > 0 ? (
        customers.map((customer) => (
          <Grid
            key={customer?.id}
            item
            xs={12}
            sm={6}
            md={4}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "stretch",
            }}
            onClick={() => handleViewDetails(customer)}
          >
            <Grid
              container
              sx={{
                borderRadius: "16px",
                backgroundColor: "white",
                border: "1px solid #D1D5DB",
                width: 340,
                boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                transition: "all 0.2s ease",
                cursor: "pointer",
                ":hover": {
                  transform: "translateY(-4px)",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                },
              }}
            >
              {/* Header */}
              <Grid
                item
                xs={12}
                sx={{
                  backgroundColor: "#32a19f",
                  color: "white",
                  borderTopLeftRadius: "16px",
                  borderTopRightRadius: "16px",
                  px: 2,
                  py: 1.2,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  minHeight: 70,
                  width: "100%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                    flex: 1,
                    marginRight: "8px",
                  }}
                >
                  <Typography
                    fontSize={14}
                    fontWeight={600}
                    noWrap
                    title={customer?.companyNameEn || "Unnamed"}
                  >
                    {i18n.language === "ar" ? customer?.companyNameAr || "Unnamed" : customer?.companyNameEn || "Unnamed"}
                  </Typography>
                  <Typography
                    fontSize={12}
                    color="white"
                    sx={{ opacity: 0.9 }}
                  >
                    {customer?.erpCustId || "ERP ID — N/A"}
                  </Typography>
                  {isApprovalMode && (
                  <Typography fontSize={12}
                    color="white"
                    sx={{ opacity: 0.9 }}>
                      <Typography component="span" fontWeight={600} fontSize={12}>
                        {t("Workflow")}
                      </Typography>
                    {`: ${t(customer?.workflowName)}`}
                  </Typography>)}
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-end",
                    justifyContent: "center",
                    minWidth: "90px",
                  }}
                >
                  <Typography
                    sx={{
                      backgroundColor: getStatusColor(customer?.customerStatus),
                      color: getStatusTextColor(customer?.customerStatus),
                      borderRadius: "30px",
                      px: 1.5,
                      py: 0.3,
                      fontSize: 10,
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                    }}
                  >
                    {t(customer?.customerStatus) || t("Unknown")}
                  </Typography>
                  {/* <Typography
                                        fontSize={11}
                                        fontWeight={500}
                                        sx={{ color: "white", mt: 0.3 }}
                                      >
                                        {formatTime(customer?.createdAt)}
                                      </Typography> */}
                                      {!isApprovalMode && (<Typography
                                        fontSize={11}
                                        fontWeight={500}
                                        color="white"
                                        sx={{  mt: 0.3 }}
                                      >
                                        {formatDate(customer?.createdAt)}
                                      </Typography>)}
                                      {isApprovalMode && (<Typography fontSize={13} fontWeight={600} color="white">
                    {/* <BusinessIcon
                      fontSize="small"
                      sx={{ mr: 0.5, verticalAlign: "middle" }}
                    />{" "} */}
                    {t(customer?.companyType) || "—"}
                  </Typography>)}
                </div>
              </Grid>

              {/* Body */}
              <Grid
                item
                xs={12}
                sx={{
                  backgroundColor: "#f7f8fa",
                  borderBottomLeftRadius: "16px",
                  borderBottomRightRadius: "16px",
                  px: 2,
                  py: 1.2,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  minHeight: 90,
                  width: "100%",
                }}
              >
                {/* Left */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    overflow: "hidden",
                    flex: 1,
                    marginRight: "8px",
                  }}
                >
                  <Typography fontSize={12} color="#666">
                    { getDropdownLabel("typeOfBusiness", customer?.typeOfBusiness) || t("Type N/A")}
                  </Typography>
                  
                  {
                  // isApprovalMode && 
                  (<>
                    <Typography fontSize={12} color="#666">
                      <Typography component="span" fontWeight={600} fontSize={12}>
                          {t("Sales Executive")}
                        </Typography>
{`: ${customer?.salesExecutiveName}`}
                  </Typography>
                  </>
                    )}
                  
                </div>

                {/* Right — Action */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-end",
                    justifyContent: "center",
                    minWidth: "90px",
                  }}
                >
                  {!isApprovalMode && (<Typography fontSize={13} fontWeight={600} color="black">
                    {/* <BusinessIcon
                      fontSize="small"
                      sx={{ mr: 0.5, verticalAlign: "middle" }}
                    />{" "} */}
                    {t(customer?.companyType) || "—"}
                  </Typography>)}
                  <Typography fontSize={12} color="#666">
                    <Typography component="span" fontWeight={600} fontSize={12}>
                        {t("Branches")}
                      </Typography>
                    {`: ${customer?.branchCount ?? 0}`}
                  </Typography>
                  {customer?.erpCustId ? (
                    <Tooltip title="View Customer Details" arrow>
                      {/* <Button
                        variant="contained"
                        size="small"
                        sx={{
                          backgroundColor: "#009688",
                          textTransform: "none",
                          fontSize: "12px",
                          borderRadius: "20px",
                          px: 2,
                          py: 0.6,
                          "&:hover": { backgroundColor: "#00796B" },
                        }}
                        // onClick={() => handleViewDetails(customer)}
                      >
                        View
                      </Button> */}
                    </Tooltip>
                  ) : (
                    !customer?.erpCustId && customer?.customerStatus?.toLowerCase() === "approved" && (<Tooltip title="Sync Customer to ERP" arrow>
                      <Button
                        variant="contained"
                        size="small"
                        sx={{
                          backgroundColor: "#f5a623",
                          color: "white",
                          textTransform: "none",
                          fontSize: "12px",
                          borderRadius: "20px",
                          px: 2,
                          py: 0.6,
                          "&:hover": { backgroundColor: "#e28d12" },
                        }}
                        onClick={() => handleSync(customer)}
                      >
                        <SyncIcon fontSize="small" />
                        &nbsp; Sync
                      </Button>
                    </Tooltip>)
                  )}
                </div>
              </Grid>
            </Grid>
          </Grid>
        ))
      ) : (
        <Typography align="center" sx={{ mt: 2 }}>
          No customers found
        </Typography>
      )}
    </Grid>
  );
}

export default CustomerCard;
